import { render, staticRenderFns } from "./RemindersModal.vue?vue&type=template&id=55306fa4&scoped=true&"
import script from "./RemindersModal.vue?vue&type=script&lang=js&"
export * from "./RemindersModal.vue?vue&type=script&lang=js&"
import style0 from "./RemindersModal.vue?vue&type=style&index=0&id=55306fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55306fa4",
  null
  
)

component.options.__file = "RemindersModal.vue"
export default component.exports